export default __webpack_public_path__ + "static/media/play_s.85d4f3b1.svg";